export default {
      id: "i-menu-capital-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/sprite.svg#i-menu-capital",
      toString: function () {
        return this.url;
      }
    }